  import React from "react";
  import { CDBIcon } from "cdbreact";
  import NavBarPeiix from "../../../components/NavBar.jsx";
  import { useSmartLinksList } from "../hooks/useSmartLinksList.js";
  import { SmartLinksListTable } from "../components/SmartLinksListTable.jsx";
  import { SmartLinksListFilters } from "../components/SmartLinksListFilter.jsx";
  import { LoadingOverlay } from "../components/LoadingOverlay";
  import { PaginationComponent } from "../components/PaginationComponent.jsx";

  export default function LinksTableView() {
    const {
      currentItemsLinks,
      totalPagesLinks,
      loadingLinks,
      errorLinks,
      filtrosLinks,
      currentPageLinks,
      handleInputChangeLinks,
      handleSelectChangeLinks,
      handlePageChangeLinks
    } = useSmartLinksList();


    const allColumnsLinks = [
      { key: "ID", label: "ID", property: "id", alwaysShow: true },
      { key: "Link", label: "Link", property: "url", alwaysShow: true },
      { key: "Estado", label: "Estado", property: "status", alwaysShow: true },
      { key: "Fecha", label: "Fecha de Creación", property: "launch_time", alwaysShow: true },
      { key: "Producto", label: "Producto", property: "product_name", alwaysShow: true },
      { key: "Precio", label: "Precio", property: "price", alwaysShow: true }, 
      { key: "Usos", label: "Usos", property: "uses", alwaysShow: true },
      { key: "Nombre", label: "Nombre", property: "name", alwaysShow: true }, 
      { key: "Direccion", label: "Direccion", property: "address", alwaysShow: true }, 
      { key: "Telefono", label: "Telefono", property: "phone", alwaysShow: true },  
      { key: "Email", label: "Email", property: "email", alwaysShow: true }, 
    ];

    return (
      <>
        <div className="Transacciones">
          <NavBarPeiix />
          <div
            className="navbar-container"
            style={{
              padding: "40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3
              className="fw-bold"
              style={{
                color: "#3E3E3E",
                fontFamily: "Montserrat, sans-serif",
                marginBottom: "0",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CDBIcon icon="link" /> Lista de Links
            </h3>
          </div>

          
          {errorLinks && (
            <p style={{ color: "red", paddingLeft: "40px", fontWeight: "bold" }}>
              Error al cargar links: {errorLinks}
            </p>
          )}

          <SmartLinksListFilters
            filtros={filtrosLinks}
            handleInputChange={handleInputChangeLinks}
            handleSelectChange={handleSelectChangeLinks}
          />

          <SmartLinksListTable
            items={currentItemsLinks}
            allColumns={allColumnsLinks}
            selectedColumns={[]} 
          />

          {/* PAGINACIÓN */}
          <br />
          <PaginationComponent 
            currentPage={currentPageLinks}
            totalPages={totalPagesLinks}
            handlePageChange={handlePageChangeLinks}
          />
        </div>

        {/*SPINNER */}
        {loadingLinks && <LoadingOverlay />}
      </>
    );
  }